import { render, staticRenderFns } from "./MusicArchive.vue?vue&type=template&id=97e6541c&scoped=true&"
import script from "./MusicArchive.vue?vue&type=script&lang=js&"
export * from "./MusicArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e6541c",
  null
  
)

export default component.exports